import { useMemo } from 'react';
import { Button, Paper } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view';
import { buildCategoryTree } from '../../utils/Category';
import { Category } from '../../interfaces/Category/Category';
import { CategoryTreeItem } from './CategoryTreeItem';
import { sharedStyles } from '../../utils/Style';
import { CategoryTreeController } from './CategoryTreeController';

interface CategoryTreeProps {
  categories: Category[];
  selectedCategory?: Category;
  onAddRoot: () => void;
  onAddChild: (parentID: number) => void;
  onDelete: () => void;
  onSelect: (id: number) => void;
}

export const CategoryTree = (props: CategoryTreeProps) => {
  const tree = useMemo(
    () => buildCategoryTree(props.categories),
    [props.categories],
  );

  return (
    <Paper sx={{ p: 3 }}>
      <CategoryTreeController
        onAddChild={props.onAddChild}
        onDelete={props.onDelete}
      >
        <SimpleTreeView
          defaultExpandedItems={props.categories.map((category) =>
            category.id.toString(),
          )}
          selectedItems={props.selectedCategory?.id.toString()}
          onSelectedItemsChange={(_, id) => props.onSelect(Number(id))}
        >
          {tree.map((category) => (
            <CategoryTreeItem key={category.id} category={category} />
          ))}
        </SimpleTreeView>
      </CategoryTreeController>

      <Button onClick={props.onAddRoot} sx={{ ...sharedStyles.buttonText }}>
        + Kategori Ekle
      </Button>
    </Paper>
  );
};
